export default __webpack_public_path__ + "static/media/Online Ordering.6ed46a04.png";